import { render, staticRenderFns } from "./CCategoryButtonNew.vue?vue&type=template&id=590a549b&scoped=true"
import script from "./CCategoryButtonNew.vue?vue&type=script&lang=js"
export * from "./CCategoryButtonNew.vue?vue&type=script&lang=js"
import style0 from "./CCategoryButtonNew.vue?vue&type=style&index=0&id=590a549b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590a549b",
  null
  
)

export default component.exports